import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root', 
})

export class SharedService {
  private valorSource = new BehaviorSubject<string>(''); 
  valorAtual = this.valorSource.asObservable();

  constructor() {}
  
  atualizarValor(novoValor: string) {
    this.valorSource.next(novoValor);
  }
}